
import { KngUploadFileState, UploadButtons } from './definitions';

export class KngUploadFileFactory
{
	public static build(): KngUploadFileState
	{
		return {
			isLoading: false,
			dragDropSection: '',
			or: '',
			uploadButtons: {
				chooseFile: 'Choose File',
				replaceFile: 'Replace File',
				tryAgain: 'Try Again'
			},
			isError: false,
			isSuccessClient: true,
			isSuccessServer: false,
			errorHeading: '',
			errorSubHeading: '',
			successMessage: '',
			dragDropImage: { iconPath: '', altText: '' },
			errorImage: { iconPath: '', altText: '' },
			successImage: { iconPath: '', altText: '' },
			fileUploadLoader: false,
			fileUploadProgressText: ''
		};
	}
	public static buildUploadButtons(): UploadButtons
	{
		return {
			chooseFile: '',
    		replaceFile: '',
    		tryAgain: ''
		};
	}
}
